export class emsWorkspace {
    uid: string;
    name: string;
    owner: string;
    subscription: string;
    features: emsWorkspaceFeature[];
}

export class emsWorkspaceFeature {
    [name: string]: boolean;
}

export class emsPlayer {
    uid: string;
    name: string; 
    picture: string; 
    nationality: string;
    languages: string; 
    position: number; 
    armrest: boolean;
    pillow: boolean;
    inears: boolean;
    notes: string;
    team: string; 
}

export class emsCompetition {
    uid: string; 
    name: string;
    stage: string; 
    logo: string; 
    background: string; 
    workspace: string;
    active: boolean;
}

export class emsTeam {
    uid: string; 
    name: string; 
    tricode: string;
    competition: string; 
    logo: string; 
    coach: string;
    coachPicture: string;
    asscoach: string;
    asscoachPicture: string;
    notes: string;
    workspace: string;
}

export class emsMatchMeta {
    workspace: string;
    competition: string; 
    teamA: string; 
    teamB: string;
    veto: string;
}

export class emsMatch {
    uid: string;
    title: string;
    matchMeta: emsMatchMeta;
    competition: emsCompetition; 
    teamA: emsTeam; 
    teamB: emsTeam;
    teamAPlayer: emsPlayer[];
    teamBPlayer: emsPlayer[];
}

export class emsVeto {
    uid: string;
    workspace: string;
    lobbyCode: string;
    competition: string;
    teamOne: string;
    teamTwo: string;
    teamOneConnected: boolean;
    teamTwoConnected: boolean;
    adminConnected: boolean;
    startingTeam: string;
    teamA: string;
    teamB: string;
    pool: emsVetoPool[];
    actions: emsVetoAction[];
    currentAction: number;
    concluded: string;
    date: string;
}

export class emsVetoAction {
    executor: string;
    type: string;
    info: string;
    log: string;
}

export class emsVetoPool {
    name: string;
    available: boolean;
}

export class emsUser {
    uid: string; 
    workspaces: { [workspaceID: string]: boolean }; 
    competitions: boolean[]; 
    teams: boolean[]; 
}

export class emsSaaSSubscription {
    competitions: number;
    name: string; 
    price: number; 
    priceID: string; 
    product: string;
    user: number;
}

export class emsBadge {
    uid: string;
    type: string;
    number: number;
    date: Date;
}

export class emsBadgeLogs {
    date: Date;
    total: number;
    aaa: number;
    crew: number;
    visitor: number;
    creator: number;
    security: number;
    voucher: number;
    other: number;
}

export class emsBadgeLogEntry {
    uid: string;
    date: Date;
}